module.exports = __webpack_public_path__ + "static/media/stubhub-card.3e06554f.png";